(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector('.announcement-bar-section');

  if (announcementBar) {
    const height = announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }
});

  } catch(e) { console.error(e); }
})();
})();
